module.exports = __webpack_public_path__ + "img/18.19dba037.jpg";